import { useState, useEffect, useRef, useCallback } from 'react';

export const useLiveFeedback = ({
  initialMessage = '',
  delay = 1000,
}: {
  initialMessage?: string;
  delay?: number;
}) => {
  const [message, setMessage] = useState(initialMessage);
  const announceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!message) return undefined;

    const clearTimer = setTimeout(() => {
      setMessage('');
    }, delay);

    return () => clearTimeout(clearTimer);
  }, [message, delay]);

  const announce = useCallback((newMessage: string) => {
    if (announceTimerRef.current) clearTimeout(announceTimerRef.current);
    setMessage('');
    announceTimerRef.current = setTimeout(() => setMessage(newMessage), 100);
  }, []);

  return [message, announce] as const;
};
